/* ============================================
   KARAK HOUSE COFFEE CO. — THEME JS
   Cart drawer, product gallery, mobile menu, animations
   ============================================ */

(function () {
  'use strict';

  /* ── Sticky header shadow ── */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const y = window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 8);
      lastScroll = y;
    }, { passive: true });
  }

  /* ── Scroll-reveal animations ── */
  const animateEls = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animateEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    animateEls.forEach((el) => io.observe(el));
  } else {
    animateEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ── Mobile menu ── */
  const mobileMenu = document.querySelector('.mobile-menu');
  document.querySelectorAll('[data-mobile-menu-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (mobileMenu) mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (mobileMenu) mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ── Cart Drawer ── */
  const drawer = document.querySelector('.drawer');
  const drawerOverlay = document.querySelector('.drawer-overlay');
  const drawerBody = document.querySelector('.drawer-body');
  const drawerFoot = document.querySelector('.drawer-foot');

  function openDrawer() {
    drawer && drawer.classList.add('is-open');
    drawerOverlay && drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer && drawer.classList.remove('is-open');
    drawerOverlay && drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); refreshCart(); openDrawer(); }));
  document.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  drawerOverlay && drawerOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  function formatMoney(cents) {
    const fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function renderDrawer(cart) {
    if (!drawerBody || !drawerFoot) return;
    const cartCounts = document.querySelectorAll('[data-cart-count]');
    cartCounts.forEach((c) => {
      c.textContent = cart.item_count;
      c.classList.toggle('is-empty', cart.item_count === 0);
    });

    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="drawer-empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn btn--outline" style="margin-top:20px">Continue shopping</a></div>';
      drawerFoot.style.display = 'none';
      return;
    }
    drawerFoot.style.display = '';
    let html = '';
    cart.items.forEach((item) => {
      const img = item.image ? item.image.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png') : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="variant">${item.variant_title}</div>` : '';
      html += `
        <div class="drawer-line" data-line-key="${item.key}">
          <a href="${item.url}" class="drawer-line-image">${img ? `<img src="${img}" alt="${item.title}">` : ''}</a>
          <div class="drawer-line-info">
            <h3><a href="${item.url}">${item.product_title}</a></h3>
            ${variant}
            <div class="qty">
              <button data-qty-change="-1" data-line="${item.key}">−</button>
              <span>${item.quantity}</span>
              <button data-qty-change="1" data-line="${item.key}">+</button>
            </div>
          </div>
          <div>
            <div class="drawer-line-price">${formatMoney(item.line_price)}</div>
            <a href="#" class="drawer-line-remove" data-remove="${item.key}">Remove</a>
          </div>
        </div>`;
    });
    drawerBody.innerHTML = html;
    drawerFoot.querySelector('.row span:last-child').textContent = formatMoney(cart.total_price);

    drawerBody.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.getAttribute('data-line');
        const delta = parseInt(btn.getAttribute('data-qty-change'), 10);
        const item = cart.items.find((i) => i.key === line);
        if (!item) return;
        const newQty = Math.max(0, item.quantity + delta);
        updateCartLine(line, newQty);
      });
    });
    drawerBody.querySelectorAll('[data-remove]').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        updateCartLine(a.getAttribute('data-remove'), 0);
      });
    });
  }

  function refreshCart() {
    fetch('/cart.js').then((r) => r.json()).then(renderDrawer).catch(() => {});
  }

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then((r) => r.json()).then(renderDrawer);
  }

  /* ── Add-to-cart from product form ── */
  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then((r) => r.json()).then((item) => {
        if (item.status) {
          alert(item.description || 'Could not add to cart.');
        } else {
          refreshCart();
          openDrawer();
        }
      }).finally(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      });
    });
  });

  // Initial cart load (for header count)
  refreshCart();

  /* ── Product gallery ── */
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.product-gallery-main');
    const thumbs = gallery.querySelectorAll('.product-gallery-thumb');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = thumb.getAttribute('data-index');
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        main.querySelectorAll('img').forEach((img) => img.classList.remove('is-active'));
        const targetImg = main.querySelector(`img[data-index="${idx}"]`);
        if (targetImg) targetImg.classList.add('is-active');
      });
    });
  });

  /* ── Variant picker (product page) ── */
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const variantData = JSON.parse(picker.getAttribute('data-variants') || '[]');
    const optionInputs = picker.querySelectorAll('input[data-option]');
    const masterSelect = picker.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const submitBtn = document.querySelector('[data-product-submit]');

    function findVariant() {
      const selected = [];
      const labels = {};
      optionInputs.forEach((inp) => {
        if (inp.checked) {
          const idx = parseInt(inp.getAttribute('data-option-index'), 10);
          selected[idx] = inp.value;
          labels[idx] = inp.value;
        }
      });
      // Update labels next to option titles
      picker.querySelectorAll('[data-option-label]').forEach((lbl) => {
        const i = parseInt(lbl.getAttribute('data-option-label'), 10);
        if (labels[i]) lbl.textContent = labels[i];
      });
      return variantData.find((v) => {
        return selected.every((val, i) => v.options[i] === val);
      });
    }

    function updateVariant() {
      const variant = findVariant();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        return;
      }
      if (masterSelect) masterSelect.value = variant.id;
      if (priceEl) priceEl.innerHTML = renderPrice(variant);
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    function renderPrice(variant) {
      let html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = `<span class="sale">${formatMoney(variant.price)}</span><span class="compare">${formatMoney(variant.compare_at_price)}</span>`;
      } else {
        html = `<span>${formatMoney(variant.price)}</span>`;
      }
      return html;
    }

    optionInputs.forEach((inp) => inp.addEventListener('change', updateVariant));
  });

  /* ── Quantity selectors ── */
  document.querySelectorAll('.quantity-selector').forEach((qs) => {
    const input = qs.querySelector('input');
    qs.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qs.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ── Hero parallax (subtle) ── */
  const heroVisual = document.querySelector('.hero-visual img');
  if (heroVisual && window.matchMedia('(min-width: 901px)').matches) {
    window.addEventListener('scroll', () => {
      const y = window.pageYOffset;
      if (y < 800) heroVisual.style.transform = `translateY(${y * 0.18}px) scale(1.05)`;
    }, { passive: true });
  }

})();
